import type { DevRequest } from '@/features/project-board/types';

export function DevRequestSummaryRow({ request, specCount }: { request: DevRequest; specCount?: number }): React.JSX.Element {
  return (
    <span className="inline-flex flex-wrap items-baseline gap-2">
      <span className="font-mono text-muted">#{request.id}</span>
      <span className="font-semibold">{request.title}</span>
      <span className="text-muted">{request.requester}{request.reviser !== null && request.reviser !== request.requester && <> → {request.reviser}</>}</span>
      {/* 목록이 원래 보이던 값(요청이 올라온 시각, 한국 시간 분 단위)을 유지한다 — 서버 접수 시각·날짜만으로 바꾸지 않는다. */}
      <span className="text-faint">{new Date(request.requestedAt).toLocaleString('ko-KR', { dateStyle: 'short', timeStyle: 'short' })}</span>
      {specCount !== undefined && <span className="text-muted">연결 스펙 {specCount}개</span>}
    </span>
  );
}
